import * as React from 'react';
import { SortableElement, SortableElementProps } from 'react-sortable-hoc';

import { trackSection } from '@webapp/utils/validators/release';
import { datesSection } from '../../../utils/validators/release';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import { generalStatus } from '../../../store/assets/selectors';

import UploadListItem from '@components/upload/upload-list-item';

interface TrackUploadItemProps {
  trackId: string;
  title: string;
  order?: number;
  assetId?: string;
  trackLength?: string;

  isUploading: boolean;
  isInstrumental: boolean;
  isExplicit: boolean;
  isClean: boolean;
  hasErrors: boolean;

  progress: number;
  artistId?: string;
  releaseId?: string;
  location: any;
  onRemove: (trackId: string, isActive: boolean) => void;
  onCancel: () => void;

  disableRemove?: boolean;
  routePrefix?: string;
  disableSorting?: boolean;
  hasNFTSwitch?: boolean;
}

interface StateProps {
  isDone: boolean;
  isDisabled: boolean;
  isLoading: boolean;
}

const mapStateToProps = (state: AppState, props: TrackUploadItemProps) => {
  const isLoading = generalStatus(state.assets) === 'uploading';
  return {
    isLoading, //asset?.acrDone
    isDone: trackSection(state, props.trackId),
    isDisabled: !datesSection(state) || isLoading,
  };
};

export const TrackUploadItem: React.FC<TrackUploadItemProps & StateProps> = (
  props
) => {
  const isActive = (trackId: string) => {
    if (!props.location.pathname.startsWith('/release/')) {
      return false;
    }

    return props.location.pathname.endsWith(`track/${trackId}`);
  };

  const handleTrackMenu = (action: string) => {
    switch (action) {
      case 'delete':
        return props.onRemove(props.trackId, isActive(props.trackId));
      default:
        return;
    }
  };

  return (
    <UploadListItem
      number={String(props.order || '0').padStart(2, '0')}
      text={props.title}
      trackLength={props.trackLength}
      active={isActive(props.trackId)}
      done={props.isDone}
      uploading={props.isUploading}
      progress={props.progress}
      isExplicit={props.isExplicit}
      isInstrumental={props.isInstrumental}
      isClean={props.isClean}
      isLoading={props.isLoading}
      error={props.hasErrors}
      onRetry={() => null}
      onCancel={props.onCancel}
      onRemove={() => props.onRemove(props.trackId, isActive(props.trackId))}
      disableRemove={props.disableRemove}
      disableSorting={props.disableSorting}
      assetId={props.assetId}
      handleTrackMenu={(action: string) => handleTrackMenu(action)}
      hasNFTSwitch={props.hasNFTSwitch}
    />
  );
};

const SortableTrackUploadItem = SortableElement(TrackUploadItem);

export default connect(mapStateToProps)(
  (props: TrackUploadItemProps & StateProps & SortableElementProps) => {
    if (props.disableSorting) {
      return <TrackUploadItem {...props} />;
    }

    return <SortableTrackUploadItem {...props} />;
  }
);
